module.exports = __webpack_public_path__ + "static/media/Hover7.8b6a9534.svg";